import { atom } from "recoil";

export const defaultAccount = {
  userName: "",
  emailAddress: "",
  roleId: null,
  firstName: "",
  lastName: "",
  isFranchise: false,
  isNonFranchise: false,
  isMexico: false,
  userPermissions: [],
  rolePermissions: [],
  token: "",
  roleName: "",
  googleApiKey: null,
  googleTimezoneApiKey: null,
};
export const accountAtom = atom({
  key: "account",
  default: defaultAccount,
});
export const loginError = atom({
  key: "loginError",
  default: undefined,
});
